<template>
  <div>
    <Multiselect
      data-test="searchUsergroups-selection"
      v-model="selection"
      style="margin-top: 0.5em;"
      class="search-usergroups"
      :options="results"
      :optionsLimit="10"
      :allow-empty="false"
      track-by="id"
      label="display_name"
      :resetAfter="true"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      :searchable="true"
      :placeholder="placeholder"
      :showNoResults="true"
      :loading="loading"
      :clearOnSelect="false"
      :preserveSearch="true"
      @search-change="search"
      @select="select"
    >
      <template slot="clear">
        <div
          v-if="selection"
          class="multiselect__clear"
          data-test="searchUsergroups-removeSelection"
          @click.prevent.stop="selection = null"
        >
          <b-icon-x font-scale="2"/>
        </div>
      </template>
      <span slot="noResult">
        {{ $t('multiselect.noResult') }}
      </span>
      <span slot="noOptions">
        {{ $t('multiselect.noOptions') }}
      </span>
    </Multiselect>
  </div>
</template>

<script>
import Multiselect from 'vue-multiselect';

import usergroupsAPI from '@/api/usergroupsAPI';
import { debounce } from 'lodash';

export default {
  name: 'SearchUsergroups',

  components: {
    Multiselect
  },

  props: {
    placeholder: {
      type: String,
      default: 'Ajouter cette organisation à des groupes d\'organisations'
    }
  },

  data() {
    return {
      selection: null,
      loading: false,
      text: null,
      results: []
 
    };
  },

  watch: {
    text: debounce(async function(newValue) {
      this.loading = true;
      await this.searchUsergroups(newValue);

      this.loading = false;
    }, 100)
  },

  created() {
    
  },

  methods: {
    async searchUsergroups(query) {
      try {
        const res = await usergroupsAPI.getUsergroupsList(['group-of-organisation'], query);
        if (res && res.results) {
          this.results = res.results;
        } else {
          this.results = [];
        }
      } catch (err) {
        console.error(err);
        this.results = [];
      }
    },

    search(text) {
      this.text = text;
    },

    select(e) {
      this.$emit('select', e);
      this.selection = null;
    }
  }
}
</script>
